module.exports = __webpack_public_path__ + "img/approve-list23.6942a414.png";